import React from "react";
import CustomModalContainer from "../../../../components/modals/CustomModalContainer";
import Button from "../../../ui/Button";

interface StepOneProps {
  open: boolean;
  onClose?: () => void;
  onSuccess?: () => void;
  onAlternateClick?: () => void;
}

const StepOne: React.FC<StepOneProps> = ({
  open,
  onClose,
  onSuccess,
  onAlternateClick,
}) => {
  if (!open) return null; // Do not render the component if it's not open

  return (
    <CustomModalContainer
      title="Reset Password"
      footer={
        <div className="flex justify-between relative bottom-0">
          <Button
            type="button"
            onClick={onAlternateClick}
            label="Alternate email"
            layout="inline" variant="ghost"
          />
          <Button
            label="Send code"
            type="submit"
            layout="inline"
            onClick={onSuccess}
          />
        </div>
      }
      open={open}
      onClose={onClose}
    >
      {/* Modal Body */}
      <div className="flex flex-col gap-8 p-6  items-center justify-center">
        <div className="bg-blue-100 text-blue-500 rounded-full p-4 w-18 h-18 ">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="w-8 h-8"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M21 8V6a2 2 0 00-2-2H5a2 2 0 00-2 2v2m18 0l-9 6-9-6m18 0v8a2 2 0 01-2 2H5a2 2 0 01-2-2V8"
            />
          </svg>
        </div>
        <div className="text-sm font-semibold text-gray-600">
          Enter an email address below to receive 6 digit OTP code
        </div>
      </div>
    </CustomModalContainer>
  );
};

export default StepOne;
